import React from 'react';
import { Empty, Spin, Tag } from 'antd';
import { Modal } from '../../design-system';

const hiddenFields = new Set(['id', 'role_id']);
const fieldLabels = {
    name: 'Role Name',
    rate: 'Public Rate',
    valid_at: 'Effective Date',
    team_members: 'Team Members'
};

const formatDateTime = (value) => {
    if (!value) return '-';
    return new Date(value).toLocaleString('en-SG', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const getActorName = (entry) => entry.user?.fullName || entry.owner?.fullName || 'System';

const formatValue = (value) => {
    if (value === null || value === undefined || value === '(empty)' || value === '(empty array)') {
        return '(empty)';
    }
    return String(value);
};

const RoleHistoryModal = ({ visible, role, history = [], loading, onClose }) => (
    <Modal visible={visible} onClose={onClose} width="medium">
        <Modal.Header
            title="View history"
            subtitle={role ? `${role.department_name} - ${role.name}` : ''}
        />
        <Modal.Body padding="default">
            {loading ? (
                <div style={{ padding: 32, textAlign: 'center' }}>
                    <Spin />
                </div>
            ) : history.length === 0 ? (
                <Empty description="No history yet" />
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {history.map((entry) => {
                        const changes = (entry.changes || []).filter(change => !hiddenFields.has(change.field));

                        return (
                            <div
                                key={entry.id}
                                style={{
                                    border: '1px solid #e8e8e8',
                                    borderRadius: 6,
                                    padding: 12,
                                    background: '#fff'
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'space-between',
                                    gap: 12,
                                    marginBottom: 8
                                }}>
                                    <div>
                                        <Tag color="default" style={{ marginBottom: 6 }}>
                                            {entry.translatedMessage || entry.message}
                                        </Tag>
                                        <div style={{ fontSize: 13, color: '#4a4a4a' }}>
                                            {getActorName(entry)}
                                        </div>
                                    </div>
                                    <div style={{ fontSize: 12, color: '#8c8c8c', whiteSpace: 'nowrap' }}>
                                        {formatDateTime(entry.timestamp)}
                                    </div>
                                </div>

                                {changes.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                        {changes.map((change) => (
                                            <div
                                                key={`${entry.id}-${change.field}`}
                                                style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: '120px 1fr',
                                                    gap: 10,
                                                    fontSize: 13
                                                }}
                                            >
                                                <div style={{ color: '#6b6b6b', fontWeight: 600 }}>
                                                    {fieldLabels[change.field] || change.fieldLabel}
                                                </div>
                                                <div style={{ color: '#262626', minWidth: 0 }}>
                                                    <span style={{ color: '#8c8c8c' }}>{formatValue(change.oldValue)}</span>
                                                    <span style={{ margin: '0 8px', color: '#bfbfbf' }}>to</span>
                                                    <span>{formatValue(change.newValue)}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div style={{ fontSize: 13, color: '#8c8c8c' }}>
                                        No field details available
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </Modal.Body>
        <Modal.Footer />
    </Modal>
);

export default RoleHistoryModal;
